import React from "react";
import PropTypes from "prop-types";

const PATHS = {
  1: "M15.83,13.5c-2,1.33-3.17,3-2.17,3.67s3.5,1.83,3.5,2.67S14,21,13.67,22.33s1.17,3.5.5,4.33S10.83,28.5,12,30.33",
  2: "M7.66,30.17c-.38-2.27,2.9-3.15,2.9-4.29S8.41,23.23,8.29,22.6s2.77-1.39,3.15-3.28-2.52-2.9-2.52-3.78,1.26-1.39,2.4-2.52m6,17a2.83,2.83,0,0,1,.95-3c1.42-1.42,2.18-2.65,1.61-3.41s-2.08-1.23-1.7-2.74,3.12-3.41,3.31-4.73-2.55-3-3.12-3.88.76-2.36,1.8-3.41,1-1.8.38-2.08",
  3: "M4.37,32.33c-.54-1,1.29-2.91,1.29-4S3.94,26.2,4.16,24.69s3.12-2.37,3.23-3.87-3-2.48-3.12-3.55,2.48-4,2.48-4m7,14.64c-.22-.43,1.29-1.88,1.78-2.8s-.65-1.83-1.08-2.26a2.2,2.2,0,0,1-.81-1.72c0-.86,1-1.61,2.42-3.23s1.61-2.1.91-3.12-2.85-2.21-2.85-2.85S17.61,9.36,17.5,7s-3.23-3.82-3.23-4.63A1.7,1.7,0,0,1,15,1.12M25.66,9.52c-.86,1.61-2.42,4.9-2.21,5.81s3.5,1.29,3.44,2.15-1.4,1.88-2.21,2.58S23,21.25,23.07,21.84,24.47,23,24.26,24s-2,2-1.94,2.91a6.53,6.53,0,0,0,.43,1.78"
};

const OFFSETS = {
  1: 15,
  2: 16,
  3: 21
};

const Smell = ({ smell, length }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 34"
    width={30}
    style={{ position: "relative", left: OFFSETS[length] }}
  >
    <path
      d={PATHS[smell]}
      style={{
        fill: "none",
        stroke: "#333",
        strokeLinejoin: "round",
        strokeLinecap: "round"
      }}
    />
  </svg>
);

Smell.propTypes = {
  length: PropTypes.oneOf([1, 2, 3]).isRequired,
  smell: PropTypes.oneOf([1, 2, 3]).isRequired
};

export default Smell;



// WEBPACK FOOTER //
// ./src/components/socks/Smell.js